import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ExgPopupComponent} from '../../modal/exg-popup/exg-popup.component';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgTableDefinition} from './IExgTableDefinition';

@Component({
  selector: 'exg-table-settings',
  templateUrl: './exg-table-settings.component.html',
  styles: []
})
export class ExgTableSettingsComponent extends ExcTranslation implements OnInit {

  @ViewChild('filterConfig', {read: ExgPopupComponent}) filterConfig!: ExgPopupComponent;
  private _tableDef: IExgTableDefinition | any = [];

  @Input()
  set tableDef(newValue) {
    this._tableDef = newValue;
    if (newValue.length > 0) {
      if (this.dynamic && this.isInit) {
        this.isInit = false;
        this.ogTableDef = JSON.parse(JSON.stringify(newValue));
        this.loadFilterConfig();
      }
    }
  }
  get tableDef(): any {
    return this._tableDef;
  }

  @Input() metaInfo: any;
  @Input() localStorageID = '';

  @Input() canOpen = false;

  @Output() save: EventEmitter<IExgTableDefinition> = new EventEmitter<IExgTableDefinition>();
  @Output() resetted: EventEmitter<IExgTableDefinition> = new EventEmitter<IExgTableDefinition>();
  @Output() doOpen: EventEmitter<IExgTableDefinition> = new EventEmitter<IExgTableDefinition>();
  @Output() tableDefChange = new EventEmitter<any>();

  /** Dynamic TableDef */
  @Input() dynamic = false;
  isInit = true;
  ogDynamicTableDef = [];
  popUpOpen = false;

  ogTableDef = [];

  constructor() {
    super();
  }


  ngOnInit(): void {
    if (!this.dynamic) {
      this.ogTableDef = JSON.parse(JSON.stringify(this.tableDef));
      this.loadFilterConfig();
      this.isInit = false;
    }
  }

  loadFilterConfig(): void {
    if (this.localStorageID.length > 0 && localStorage[this.localStorageID]) {
      const p = JSON.parse(localStorage[this.localStorageID]);
      this.rearrangeColumns(p);
    }
  }

  rearrangeColumns(tabledef: IExgTableDefinition | any): void {
    let searchKey = 'value';
    const tmpTableDef: any = Array.from(this.tableDef);
    if (this.dynamic) { searchKey = 'oldID'; }
    for (let i = 0; i < tabledef.length; i++) {
      const index = ExcCoreModule.Array.GetObjectIndex(tmpTableDef, searchKey, tabledef[i][searchKey]);
      if (index > -1) {
        moveItemInArray(tmpTableDef, index, i);
        for (const key in tmpTableDef[i]) {
          if (tabledef[i].hasOwnProperty(key)) {
            tmpTableDef[i][key] = tabledef[i][key];
          }
        }
      }
    }
    this.tableDefChange.emit(tmpTableDef);
  }

  openFilterConfig(e: any): void {
    this.filterConfig.openUnderLeft(e);
    this.popUpOpen = true;
  }

  saveFilterConfig(): void {
    if (this.localStorageID.length > 0) {
      localStorage[this.localStorageID] = JSON.stringify(this.tableDef);
    }
    this.save.emit(this.tableDef);
    this.closeFilterConfig();
  }

  resetFilterConfig(): void {
    const p = JSON.parse(JSON.stringify(this.ogTableDef));
    this.rearrangeColumns(p);
    this.resetted.emit(this.tableDef);
  }

  closeFilterConfig(): void {
    this.filterConfig.close();
    this.popUpOpen = false;
  }

  dragTableDropEvent(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.tableDef, event.previousIndex, event.currentIndex);
  }

  isFilterSet(value: any): boolean {
    if (this.metaInfo?.dataFilter && value in this.metaInfo?.dataFilter && this.metaInfo?.dataFilter[value]) {
      return this.metaInfo.dataFilter[value].length > 0;
    }
    return false;
  }

}
